"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _nav = _interopRequireDefault(require("./nav"));

var currIndex = null;
var nextIndex = 0;
var DEFAULT_NAV_WIDTH = 86;

var Navs = function Navs(_ref) {
  var items = _ref.items,
    offset = _ref.offset,
    duration = _ref.duration,
    delay = _ref.delay,
    coverWidth = _ref.coverWidth,
    navWidth = _ref.navWidth,
    linkClass = _ref.linkClass,
    divStyle = _ref.divStyle,
    ulStyle = _ref.ulStyle,
    listStyle = _ref.listStyle,
    hrefStyle = _ref.hrefStyle,
    activeLinkClass = _ref.activeLinkClass,
    handleClick = _ref.handleClick,
    disabledElement = _ref.disabledElement,
    navWidth = navWidth ? navWidth : DEFAULT_NAV_WIDTH,
    coverWidth = coverWidth ? coverWidth : items.length * navWidth;
  var coverStyle = {
    height: "100%",
    overflow: "hidden",
    //WebkitMaskBoxImage: "-webkit-linear-gradient(left, transparent, white 50%, transparent)"
  };
  var navsStyle = {
    margin: 0,
    //left: coverWidth / 2 - 43,
    paddingLeft: 0,
    position: "fixed",
    //height: "100%",
    display: "flex",
    listStyle: "none"
  };

  var navsNode = _react.default.createRef();

  return _react.default.createElement("div", {
    style: divStyle ? divStyle : coverStyle
  }, _react.default.createElement("ul", {
    style: ulStyle ? ulStyle : navsStyle,
    ref: navsNode,
    id: 'main-list-element'
  }, items.map(function (item, i) {
    return _react.default.createElement(_nav.default, {
      key: i,
      index: i,
      item: item,
      offset: offset,
      duration: duration,
      delay: delay,
      moveNavs: handleClick,
      width: navWidth,
      linkClass: linkClass,
      hrefStyle: hrefStyle,
      listStyle: listStyle,
      disabledElement: disabledElement,
      activeLinkClass: activeLinkClass,
    });
  })));
};

Navs.propTypes = {
  items: _propTypes.default.array.isRequired,
  offset: _propTypes.default.number,
  duration: _propTypes.default.number,
  delay: _propTypes.default.number,
  coverWidth: _propTypes.default.number,
  navWidth: _propTypes.default.number
};
var _default = Navs;
exports.default = _default;